import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navigation from '@/components/Navigation';
import { Card } from '@/components/ui/card';
import { ArrowRight, BookOpen } from 'lucide-react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';
const API = `${BACKEND_URL}/api`;

export default function Modules({ user }) {
  const [modules, setModules] = useState([]);

  useEffect(() => {
    const fetchModules = async () => {
      try {
        const response = await axios.get(`${API}/modules`, { withCredentials: true });
        setModules(response.data);
      } catch (error) {
        console.error('Error fetching modules:', error);
      }
    };
    fetchModules();
  }, []);

  return (
    <div className="min-h-screen">
      <Navigation user={user} />

      <main className="container mx-auto px-4 md:px-8 py-16">
        <div className="mb-16">
          <div className="flex items-center gap-3 mb-4">
            <BookOpen className="h-8 w-8" strokeWidth={1.5} />
            <h1 className="text-4xl md:text-6xl font-bold tracking-tight leading-none" style={{ fontFamily: 'Manrope, sans-serif' }} data-testid="modules-title">
              Programa AIFT
            </h1>
          </div>
          <p className="text-lg text-muted-foreground max-w-2xl">
            6 módulos completos sobre transformação AI-First, desde fundamentos até implementação prática.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {modules.map((module, index) => (
            <Link key={module.module_id} to={`/modules/${module.module_id}`} data-testid={`module-card-${module.module_id}`}>
              <Card className="p-8 h-full hover:border-primary/50 transition-colors duration-300 rounded-none border border-border group">
                <div className="flex items-start gap-6">
                  <div className="text-4xl font-bold text-muted-foreground/20" style={{ fontFamily: 'Manrope, sans-serif' }}>
                    {String(index + 1).padStart(2, '0')}
                  </div>
                  <div className="flex-1">
                    <div className="text-xs uppercase tracking-wide text-muted-foreground mb-2">
                      Módulo {module.order}
                    </div>
                    <h3 className="text-2xl font-bold mb-2" style={{ fontFamily: 'Manrope, sans-serif' }}>
                      {module.title}
                    </h3>
                    <p className="text-sm font-medium text-muted-foreground mb-4">{module.subtitle}</p>
                    <p className="text-base leading-relaxed mb-6">{module.description}</p>

                    {module.essential_content && (
                      <div className="mb-4">
                        <div className="text-xs uppercase tracking-wide text-muted-foreground mb-2">Conteúdo Essencial</div>
                        <ul className="space-y-1">
                          {module.essential_content.topics?.map((topic, i) => (
                            <li key={i} className="text-sm flex items-start gap-2">
                              <span className="text-muted-foreground">•</span>
                              <span>{topic}</span>
                            </li>
                          ))}
                        </ul>
                      </div>
                    )}

                    <div className="mt-6 pt-6 border-t border-border">
                      <div className="flex items-center gap-2 text-sm font-medium uppercase tracking-wide group-hover:gap-3 transition-all">
                        Acessar Módulo <ArrowRight className="h-4 w-4" />
                      </div>
                    </div>
                  </div>
                </div>
              </Card>
            </Link>
          ))}
        </div>
      </main>
    </div>
  );
}